import * as R from 'ramda';
import { IJsonQuery, TGeoValue } from 'shared/types/api-models/common/json_query';
import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { AddressType } from '../../../store/offer';

/**
  Если есть raion, берем его id, либо берем самый крупный id у location.
  Это сделано в рамках эксперимента. Если эксперимент будет признан удачным,
  корректный jsonQuery для объявлений загородной недвижимости будет
  формироваться на стороне бэкенда
*/
export function getJsonQuery(offer: IOfferSchema) {
  const { dealType, offerType, geo } = offer;

  const addressSubscription = R.reverse(geo.address).find(
    item =>
      item.type === AddressType.Location ||
      item.type === AddressType.Raion ||
      item.type === AddressType.District ||
      item.type === AddressType.Okrug,
  );

  const geoValue = {
    type: addressSubscription?.type === AddressType.Location ? AddressType.Location : AddressType.District,
    id: addressSubscription?.id,
  } as TGeoValue;

  const jsonQuery: IJsonQuery = {
    _type: `${offerType}${dealType}`,
    engine_version: {
      type: 'term',
      value: 2,
    },
    geo: {
      type: 'geo',
      value: [geoValue],
    },
  };

  return jsonQuery;
}
